export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-500/10 via-accent-500/10 to-primary-500/5 border border-primary-200/30 p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-background-50"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                联系我们
              </h2>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                欢迎漫画作者、汉化组、内容创作者与我们联系投稿与合作。亲亲漫画致力于为读者提供海量优质的免费漫画阅读体验，期待与更多优秀创作者携手，共同打造好看的漫画大全平台。投稿或商务合作请发送邮件，我们将在 48 小时内回复。
              </p>
            </div>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex-shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-1-line"></i>
              立即咨询
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}